const PLACEHOLDER = process.env.PUBLIC_URL + '/images/';

/**
 * Current projects data.
 * Update this array as projects are added/completed.
 */
const projects = [
  {
    id: 1,
    title: 'Luxury Bespoke Marble Effect Floor',
    location: 'Swansea, Wales',
    status: 'In Progress',
    category: 'Surfaces & Finishes',
    description:
      'A stunning hand-poured marble-effect epoxy resin floor for a modern kitchen. Featuring elegant grey veining on a pristine white base, this seamless surface delivers the timeless look of natural marble with superior durability. That floor is already looking like a showstopper, and it\'s not even in its final form yet! There is something incredibly satisfying about seeing the "raw" artistry of a resin pour before that final lens-like depth kicks in.',
    image: PLACEHOLDER + 'luxury-marble-effect-floor.png',
    services: ['Epoxy Resin Floors', 'Marble Effect Floors', 'Kitchen Renovation'],
    progressLink: 'https://www.facebook.com/share/p/1K5yz7y65e/',
    timeline: [
      { label: 'Mock up to customer requirements', complete: true },
      { label: 'Surface level the floor', complete: true },
      { label: 'Lay the resin and design', complete: true },
      { label: 'Apply final finish, gloss & protection', complete: false },
    ],
    disclosure: {
      trigger: 'Here is a description tailored to highlight the craftsmanship and the upcoming transformation:',
      sections: [
        {
          heading: 'Bespoke Artistry: The Marble-Effect Resin Floor',
          body: 'This stunning marble-effect resin floor is a masterclass in custom interior design. Far from a standard "off-the-shelf" flooring solution, this surface has been hand-poured and artistically manipulated to harmonize perfectly with the modern kitchen architecture.',
        },
        {
          heading: 'Tailored to the Space',
          body: 'The floor serves as a seamless canvas, specifically designed to bridge the gap between the crisp white cabinetry and the natural light flowing through the space.',
          bullets: [
            'The Palette: The base is a clean, luminous white, designed to catch and bounce light into every corner of the room, making the kitchen feel expansive and airy.',
            'The Veining: The custom grey marbling was applied with precision, mimicking the organic flow of natural stone. These "fractures" were strategically placed to complement the angles of the kitchen island and cabinetry, ensuring the floor feels like an intentional extension of the furniture rather than just a surface beneath it.',
          ],
        },
        {
          heading: 'The Evolution: The Final Top Coat',
          body: 'While the floor currently showcases a beautiful satin-like flow, it is currently in its penultimate stage. The upcoming application of the high-gloss clear top coat will act as a transformative "liquid glass" layer. Once applied, this final coat will:',
          bullets: [
            'Magnify the Detail: The depth of the grey veining will be visually "pulled" to the surface, making the patterns appear three-dimensional.',
            'Amplify the Lighting: The gloss will turn the floor into a mirror-like surface, doubling the impact of both the under-cabinet LEDs and the natural daylight.',
            'Ensure Longevity: Beyond the aesthetics, this final seal provides the durable, high-traffic protection necessary for the heart of the home.',
          ],
        },
      ],
    },
  },
];

export default projects;
